<template>
  <div
    class="ImageSizeSelect"
    :class="rootClaases">
    <!-- Image -->
    <MultiImage
      :image="image"
      :size="sizeToUse"
      preview />

    <!-- Size select -->
    <DotMenu
      type="arrow"
      size="small"
      :use-component="ImageSizeSelectMenu"
      :dataToComponent="{ image }"
      @size-click="onSizeClick" />

    <!-- Size info -->
    <div class="SizeInfoTags">
      <div
        class="Tag"
        v-for="tag in sizeTags"
        :key="tag">{{ tag }}</div>
    </div>
  </div>
</template>

<script>
import DotMenu from '@/components/DotMenu/DotMenu'
import ImageSizeSelectMenu from '@/components/Images/ImageSizeSelectMenu'
import MultiImage from '@/components/Images/MultiImage'

export default {
  name: 'ImageSizeSelect',
  props: {
    image: {
      type: Object,
      required: true,
    },
    boxSize: {
      type: String,
      required: false,
      default: 'medium', // 'medium' | 'small'
    },
    defaultSize: {
      type: String,
      required: false,
      default: 'small',
    },
  },
  data() {
    return {
      ImageSizeSelectMenu,
      selecedSize: null,
    }
  },
  computed: {
    rootClaases() {
      return {
        BoxSizeMedium: this.boxSize === 'medium',
        BoxSizeSmall: this.boxSize === 'small',
      }
    },
    sizeToUse() {
      return this.selecedSize || this.defaultSize
    },
    sizeTags() {
      const tags = []

      const sizeItem = this.mixGetImageSizeItem({ imageObject: this.image, size: this.sizeToUse })

      if (sizeItem) {
        tags.push(this.mixGetSizeWordbook(sizeItem.name))
        tags.push(`${ sizeItem.maxSize || sizeItem.minSize }px`)
      }
      else {
        tags.push(this.mixGetSizeWordbook('base'))
        tags.push(`${ this.image.base.maxSize || this.image.base.minSize }px`)
      }

      return tags
    },
  },
  methods: {
    onSizeClick(size) {
      this.selecedSize = size
    },
  },
  components: {
    DotMenu,
    MultiImage,
  },
}
</script>

<style lang="stylus" scoped>
  .ImageSizeSelect
    position relative
    background-color #fff
    &.BoxSizeMedium
      box(160px)
    &.BoxSizeSmall
      box(100px)

  .SizeInfoTags
    position absolute
    bottom 0px
    left 2.5px
    display flex
    .Tag
      line-height 1
      font-size 0.75rem
      padding 2.5px
      background-color rgba($color_grey_lighter, 0.75)
      margin 5px 2.5px
</style>
